import { CmsMaster } from "./Values";
export const RutaBase = CmsMaster.sUrl;
//export const RutaBase = 'http://localhost:49538/';
//export const RutaBase = 'http://187.189.192.199:8181/';
//export const RutaBase = 'https://democmsn035.azurewebsites.net/';
//export const RutaBase = 'http://back-cms-n-035.azurewebsites.net/';
//export const RutaBase = 'http://localhost:49538/';
//export const RutaBase = 'https://back-cms-n-035.azurewebsites.net/';

//APIS NUEVAS
export const EliminarEncuestaUsuario = (IDEncuesta) => {
  const URL = RutaBase + "api/EliminarEncuestaUsuario";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDEncuesta: IDEncuesta,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {});
};

export const GuardarBitacoraTicket = (
  IDTicket,
  Estado,
  Acciones,
  IDConsultor,
  IDUsuario,
  IDEmpresa
) => {
  const URL = RutaBase + "api/GuardarBitacoraTicket";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDTicket: IDTicket,
      Estado: Estado,
      Acciones: Acciones,
      IDConsultor: IDConsultor,
      IDUsuario: IDUsuario,
      IDEmpresa: IDEmpresa,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {});
};

export const MostrarTickets = (IDEmpresa, IDConsultor, Tipo) => {
  const URL = RutaBase + "api/MostrarTickets";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDEmpresa: IDEmpresa,
      IDConsultor: IDConsultor,
      Tipo: Tipo,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {});
};

export const GuardarTicket = (
  IDTicket,
  Descripcion,
  Plataforma,
  Tipo,
  Prioridad,
  Estado,
  Imagen,
  fileImagen,
  IDConsultor,
  IDUsuario,
  IDEmpresa,
  Fecha,
  ZonaHoraria
) => {
  const formData = new FormData();

  formData.append("IDTicket", IDTicket);
  formData.append("Descripcion", Descripcion);
  formData.append("Plataforma", Plataforma);
  formData.append("Tipo", Tipo);
  formData.append("Prioridad", Prioridad);
  formData.append("Estado", Estado);
  formData.append("Imagen", Imagen);
  formData.append("fileImagen", fileImagen);
  formData.append("IDConsultor", IDConsultor);
  formData.append("IDUsuario", IDUsuario);
  formData.append("IDEmpresa", IDEmpresa);
  formData.append("Fecha", Fecha);
  formData.append("ZonaHoraria", ZonaHoraria);
  const url = RutaBase + "api/GuardarTicket";
  return fetch(url, {
    method: "POST",
    body: formData,
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const IniciarSesionCMSConsultor = (User, Pass, IDEmpresa) => {
  const URL = RutaBase + "api/IniciarSesionCMSConsultor";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      usuario: User,
      contrasena: Pass,
      IDEmpresa: IDEmpresa,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      // console.warn(error);
    });
};

export const IniciarSesionEmpleado = (User, Pass, IDEmpresa) => {
  const URL = RutaBase + "api/IniciarSesionEmpleado";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      usuario: User,
      contrasena: Pass,
      IDEmpresa: IDEmpresa,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      // console.warn(error);
    });
};

export const MostrarPlanAccion = (IDUsuario, IDEncuestaEmpresa) => {
  const URL = RutaBase + "api/MostrarPlanAccion";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDUsuario: IDUsuario,
      IDEncuestaEmpresa: IDEncuestaEmpresa,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {});
};

export const MostrarResultadosEmpresa = (IDUsuario, IDEncuestaEmpresa) => {
  const URL = RutaBase + "api/MostrarResultadosEmpresa";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDUsuario: IDUsuario,
      IDEncuestaEmpresa: IDEncuestaEmpresa,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {});
};

export const MostrarPoliticaRiesgo = (IDUsuario, IDEmpresa) => {
  const URL = RutaBase + "api/MostrarPoliticaRiesgo";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDUsuario: IDUsuario,
      IDEmpresa: IDEmpresa,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {});
};

export const MostrarPreguntasFrecuentes = () => {
  const URL = RutaBase + "api/MostrarPreguntasFrecuentes";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({}),
  })
    .then((response) => response.json())
    .catch((error) => {});
};

export const MostrarClientes = (IDConsultor, IDCliente, Tipo) => {
  const URL = RutaBase + "api/MostrarClientes";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDConsultor: IDConsultor,
      IDCliente: IDCliente,
      Tipo: Tipo,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {});
};

export const MostrarConsultores = (IDConsultor) => {
  const URL = RutaBase + "api/MostrarConsultores";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDConsultor: IDConsultor,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {});
};

export const IniciarSesionEmpresa = (User, Pass) => {
  const URL = RutaBase + "api/LoginEmpresa";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      usuario: User,
      contrasena: Pass,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      // console.warn(error);
    });
};

export const MostrarDatosEmpresa = (IDEmpresa) => {
  const URL = RutaBase + "api/MostrarDatosEmpresa";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDEmpresa: IDEmpresa,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const MostrarUsuariosEmpresa = (
  IDEmpresa,
  IDUsuario,
  Busqueda,
  Skip,
  Take
) => {
  const URL = RutaBase + "api/MostrarUsuariosEmpresa";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDEmpresa: IDEmpresa,
      IDUsuario: IDUsuario,
      Busqueda: Busqueda,
      Skip: Skip,
      Take: Take,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const MostrarEncuestasEmpresa = (
  IDEncuestaEmpresa,
  IDEmpresa,
  Skip,
  Take
) => {
  const URL = RutaBase + "api/MostrarEncuestasEmpresa";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDEncuestaEmpresa: IDEncuestaEmpresa,
      IDEmpresa: IDEmpresa,
      Skip: Skip,
      Take: Take,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const MostrarEncuestas = (
  IDEmpresa,
  IDEncuesta,
  IDEncuestaEmpresa,
  Skip,
  Take,
  IDUsuario
) => {
  console.log(
    "API",
    IDEmpresa,
    IDEncuesta,
    IDEncuestaEmpresa,
    Skip,
    Take,
    IDUsuario
  );
  const URL = RutaBase + "api/MostrarEncuestas";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDEmpresa: IDEmpresa,
      IDEncuesta: IDEncuesta,
      IDEncuestaEmpresa: IDEncuestaEmpresa,
      Skip: Skip,
      Take: Take,
      IDUsuario: IDUsuario == undefined ? 0 : IDUsuario,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const MostrarEncuestasUsuariosAPP = (IDUsuario) => {
  const URL = RutaBase + "api/MostrarEncuestasUsuariosAPP";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDUsuario: IDUsuario,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const ActualizarEmpresa = (
  iIdUsuario,
  sNombre,
  sNombreCorto,
  sRfc,
  sCelular,
  sTelefono,
  sCalle,
  sColonia,
  sCodigoPostal,
  sMunicipioEstado,
  sActividad,
  iIdEmpresa,
  sImagen,
  fileImagen
) => {
  const formData = new FormData();
  formData.append("IDUsuario", iIdUsuario);
  formData.append("Nombre", sNombre);
  formData.append("NombreCorto", sNombreCorto);
  formData.append("Rfc", sRfc);
  formData.append("Celular", sCelular);
  formData.append("Telefono", sTelefono);
  formData.append("Calle", sCalle);
  formData.append("Colonia", sColonia);
  formData.append("CodigoPostal", sCodigoPostal);
  formData.append("MunicipioEstado", sMunicipioEstado);
  formData.append("Actividad", sActividad);
  formData.append("IDEmpresa", iIdEmpresa);
  formData.append("Imagen", sImagen);
  formData.append("fileImagen", fileImagen);

  const url = RutaBase + "api/ActualizarEmpresa";
  return fetch(url, {
    method: "POST",
    body: formData,
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const MostrarAyuda = (IDEmpresa) => {
  const URL = RutaBase + "api/MostrarAyuda";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDEmpresa: IDEmpresa,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const AgregarAyuda = (
  IDPregunta,
  IDSetPregunta,
  IdEmpresa,
  DescripcionAyuda
) => {
  const URL = RutaBase + "api/AgregarAyuda";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDPregunta: IDPregunta,
      IDSetPregunta: IDSetPregunta,
      IdEmpresa: IdEmpresa,
      DescripcionAyuda: DescripcionAyuda,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const ActualizarAyuda = (
  IDAyuda,
  IDPregunta,
  IDSetPregunta,
  IdEmpresa,
  DescripcionAyuda
) => {
  const URL = RutaBase + "api/ActualizarAyuda";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDAyuda: IDAyuda,
      IDPregunta: IDPregunta,
      IDSetPregunta: IDSetPregunta,
      IdEmpresa: IdEmpresa,
      DescripcionAyuda: DescripcionAyuda,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const EliminarAyuda = (
  IDAyuda,
  IDPregunta,
  IDSetPregunta,
  IdEmpresa
) => {
  const URL = RutaBase + "api/EliminarAyuda";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDAyuda: IDAyuda,
      IDPregunta: IDPregunta,
      IDSetPregunta: IDSetPregunta,
      IdEmpresa: IdEmpresa,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const EnvioMensajes = (
  IDsUsuarios,
  IDEncuesta,
  sCorreos,
  boolEnviarCorreo,
  boolEnviarPush,
  IDEmpresa,
  sTitulo,
  sMensaje
) => {
  console.log("---", {
    IDsUsuarios: IDsUsuarios,
    IDEncuesta: IDEncuesta,
    sCorreos: sCorreos,
    boolEnviarCorreo: boolEnviarCorreo,
    boolEnviarPush: boolEnviarPush,
    IDEmpresa: IDEmpresa,
    sTitulo: sTitulo,
    sMensaje: sMensaje,
  });
  const URL = RutaBase + "api/EnvioMensajes";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDsUsuarios: IDsUsuarios,
      IDEncuesta: IDEncuesta,
      sCorreos: sCorreos,
      boolEnviarCorreo: boolEnviarCorreo,
      boolEnviarPush: boolEnviarPush,
      IDEmpresa: IDEmpresa,
      sTitulo: sTitulo,
      sMensaje: sMensaje,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const ListadoDudasSugerencia = (IDEmpresa) => {
  const URL = RutaBase + "api/ListadoDudasSugerencia";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDEmpresa: IDEmpresa,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const ActualizarDudasSugerencia = (
  IDEmpresa,
  IDDudasSugerencias,
  Titulo,
  Descripcion
) => {
  const URL = RutaBase + "api/ActualizarDudasSugerencia";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDEmpresa: IDEmpresa,
      IDDudasSugerencias: IDDudasSugerencias,
      Titulo: Titulo,
      Descripcion: Descripcion,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const ListadoPreguntaSetPregunta = (IDEmpresa) => {
  const URL = RutaBase + "api/ListadoPreguntaSetPregunta";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDEmpresa: IDEmpresa,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const FijarEncuestaEmpresaUsuario = (IDUsuario, IDEncuestaEmpresa) => {
  const URL = RutaBase + "api/FijarEncuestaEmpresaUsuario";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDUsuario: IDUsuario,
      IDEncuestaEmpresa: IDEncuestaEmpresa,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const SendNotification = (IDEmpresa, IDUsuario, Titulo, Mensaje) => {
  const URL = RutaBase + "api/SendNotification";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDEmpresa: IDEmpresa,
      IDUsuario: IDUsuario,
      Titulo: Titulo,
      Mensaje: Mensaje,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const ListadoAvisos = (IDEmpresa) => {
  const URL = RutaBase + "api/ListadoAvisos";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDEmpresa: IDEmpresa,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const ListadoAvisosCMS = (IDEmpresa) => {
  const URL = RutaBase + "api/ListadoAvisosCMS";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDEmpresa: IDEmpresa,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const AltaAviso = (
  Descripcion,
  DetalleAviso,
  Vigencia,
  IDUsuario,
  IDEmpresa,
  file
) => {
  const formData = new FormData();
  formData.append("Descripcion", Descripcion);
  formData.append("DetalleAviso", DetalleAviso);
  formData.append("Vigencia", Vigencia);
  formData.append("IDUsuario", IDUsuario);
  formData.append("IDEmpresa", IDEmpresa);
  formData.append("file", file);
  const url = RutaBase + "api/AltaAviso";
  return fetch(url, {
    method: "POST",
    body: formData,
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const BajaAviso = (IDEmpresa, IDAviso) => {
  const URL = RutaBase + "api/BajaAviso";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDEmpresa: IDEmpresa,
      IDAviso: IDAviso,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const ActualizarAviso = (IDEmpresa, IDAviso, Vigencia, Estatus) => {
  const URL = RutaBase + "api/ActualizarAviso";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDEmpresa: IDEmpresa,
      IDAviso: IDAviso,
      Estatus: Estatus,
      Vigencia: Vigencia,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const CambiarContrasena = (IDUsuario, Pass) => {
  const URL = RutaBase + "api/CambiarContrasenaAPP";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDUsuario: IDUsuario,
      Pass: Pass,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const SubirArchivoPFPRS = (IDEmpresa, file) => {
  const formData = new FormData();
  formData.append("IDEmpresa", IDEmpresa);
  formData.append("file", file);
  const url = RutaBase + "api/SubirArchivoPFPRS";
  return fetch(url, {
    method: "POST",
    body: formData,
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const guardarArchivoPlanAccion = (
  IDEmpresa,
  IDEncuestaEmpresa,
  file
) => {
  const formData = new FormData();
  formData.append("IDEmpresa", IDEmpresa);
  formData.append("IDEncuestaEmpresa", IDEncuestaEmpresa);
  formData.append("file", file);
  const url = RutaBase + "api/guardarArchivoPlanAccion";
  return fetch(url, {
    method: "POST",
    body: formData,
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const guardarArchivoResultadosEmpresa = (
  IDEmpresa,
  IDEncuestaEmpresa,
  file
) => {
  const formData = new FormData();
  formData.append("IDEmpresa", IDEmpresa);
  formData.append("IDEncuestaEmpresa", IDEncuestaEmpresa);
  formData.append("file", file);
  const url = RutaBase + "api/guardarArchivoResultadosEmpresa";
  return fetch(url, {
    method: "POST",
    body: formData,
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const ResultadoCuestionarioITSATS = (
  IdEncuesta,
  IdEncuestaEmpresa,
  IdUsuario,
  Fecha_Creacion_Inicio,
  Fecha_Creacion_Fin,
  Departamento,
  Area,
  Tipo_Puesto,
  Tipo_Contratacion,
  Tipo_Personal,
  Jornada_Trabajo,
  Sexo,
  sUsuarios,
  IdUsuarioConsultante
) => {
  console.log("ResultadoCuestionarioITSATS", IdUsuarioConsultante);

  const URL = RutaBase + "api/Resultado_Cuestionario_ITSATS";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IdEncuesta: IdEncuesta,
      IdEncuestaEmpresa: IdEncuestaEmpresa,
      IdUsuario: IdUsuario,
      Fecha_Creacion_Inicio: Fecha_Creacion_Inicio,
      Fecha_Creacion_Fin: Fecha_Creacion_Fin,
      Departamento: Departamento,
      Area: Area,
      Tipo_Puesto: Tipo_Puesto,
      Tipo_Contratacion: Tipo_Contratacion,
      Tipo_Personal: Tipo_Personal,
      Jornada_Trabajo: Jornada_Trabajo,
      Sexo: Sexo,
      IdUsuarioConsultante:
        IdUsuarioConsultante == undefined ? 0 : IdUsuarioConsultante,
      sUsuarios: sUsuarios == undefined ? "" : sUsuarios,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const ResultadoCuestionarioIFRPCT = (
  IdEncuesta,
  IdEncuestaEmpresa,
  IdUsuario,
  Fecha_Creacion,
  Fecha_Creacion_Fin,
  Departamento,
  Area,
  Tipo_Puesto,
  Tipo_Contratacion,
  Tipo_Personal,
  Jornada_Trabajo,
  Sexo,
  sUsuarios
) => {
  console.log("ResultadoCuestionarioIFRPCT", sUsuarios);
  const URL = RutaBase + "api/Resultado_Cuestionario_IFRPCT";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IdEncuesta: IdEncuesta,
      IdEncuestaEmpresa: IdEncuestaEmpresa,
      IdUsuario: IdUsuario,
      Fecha_Creacion_Inicio: Fecha_Creacion,
      Fecha_Creacion_Fin: Fecha_Creacion_Fin,
      Departamento: Departamento,
      Area: Area,
      Tipo_Puesto: Tipo_Puesto,
      Tipo_Contratacion: Tipo_Contratacion,
      Tipo_Personal: Tipo_Personal,
      Jornada_Trabajo: Jornada_Trabajo,
      Sexo: Sexo,
      sUsuarios: sUsuarios == undefined ? "" : sUsuarios,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const ResultadoCuestionarioIFRPEOCT = (
  IdEncuesta,
  IdEncuestaEmpresa,
  IdUsuario,
  Fecha_Creacion,
  Fecha_Creacion_Fin,
  Departamento,
  Area,
  Tipo_Puesto,
  Tipo_Contratacion,
  Tipo_Personal,
  Jornada_Trabajo,
  Sexo,
  sUsuarios
) => {
  console.log("ResultadoCuestionarioIFRPEOCT", sUsuarios);
  const URL = RutaBase + "api/Resultado_Cuestionario_IFRPEOCT";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IdEncuesta: IdEncuesta,
      IdEncuestaEmpresa: IdEncuestaEmpresa,
      IdUsuario: IdUsuario,
      Fecha_Creacion_Inicio: Fecha_Creacion,
      Fecha_Creacion_Fin: Fecha_Creacion_Fin,
      Departamento: Departamento,
      Area: Area,
      Tipo_Puesto: Tipo_Puesto,
      Tipo_Contratacion: Tipo_Contratacion,
      Tipo_Personal: Tipo_Personal,
      Jornada_Trabajo: Jornada_Trabajo,
      Sexo: Sexo,
      sUsuarios: sUsuarios == undefined ? "" : sUsuarios,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const ConsultaEncuestas = (
  IdEncuesta,
  IdEncuestaEmpresa,
  IdUsuario,
  Fecha_Creacion,
  Fecha_Creacion_Fin,
  Obtener,
  Departamento,
  Area,
  Tipo_Puesto,
  Tipo_Contratacion,
  Tipo_Personal,
  Jornada_Trabajo,
  Sexo
) => {
  const URL = RutaBase + "api/Consulta_Encuestas";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IdEncuesta: IdEncuesta,
      IdEncuestaEmpresa: IdEncuestaEmpresa,
      IdUsuario: IdUsuario,
      Fecha_Creacion_Inicio: Fecha_Creacion,
      Fecha_Creacion_Fin: Fecha_Creacion_Fin,
      Obtener: Obtener, //Encuesta || EncuestasConRespuestas
      Departamento: Departamento,
      Area: Area,
      Tipo_Puesto: Tipo_Puesto,
      Tipo_Contratacion: Tipo_Contratacion,
      Tipo_Personal: Tipo_Personal,
      Jornada_Trabajo: Jornada_Trabajo,
      Sexo: Sexo,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const ConsultaTotalEncuestas = (
  IdEncuesta,
  IdEncuestaEmpresa,
  IdUsuario,
  Fecha_Creacion_Inicio,
  Fecha_Creacion_Fin,
  Departamento,
  Area,
  Tipo_Puesto,
  Tipo_Contratacion,
  Tipo_Personal,
  Jornada_Trabajo,
  Sexo
) => {
  const URL = RutaBase + "api/Consulta_Total_Encuestas";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IdEncuesta: IdEncuesta,
      IdEncuestaEmpresa: IdEncuestaEmpresa,
      IdUsuario: IdUsuario,
      Fecha_Creacion_Inicio: Fecha_Creacion_Inicio,
      Fecha_Creacion_Fin: Fecha_Creacion_Fin,
      Departamento: Departamento,
      Area: Area,
      Tipo_Puesto: Tipo_Puesto,
      Tipo_Contratacion: Tipo_Contratacion,
      Tipo_Personal: Tipo_Personal,
      Jornada_Trabajo: Jornada_Trabajo,
      Sexo: Sexo,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

//reportes de valor
export const RVGlobal = (
  IdEncuesta,
  IdEncuestaEmpresa,
  IdUsuario,
  Fecha_Creacion_Inicio,
  Fecha_Creacion_Fin,
  Departamento,
  Area,
  Tipo_Puesto,
  Tipo_Contratacion,
  Tipo_Personal,
  Jornada_Trabajo,
  Sexo,
  sUsuarios
) => {
  console.log(
    JSON.stringify({
      IdEncuesta: IdEncuesta,
      IdEncuestaEmpresa: IdEncuestaEmpresa,
      IdUsuario: IdUsuario,
      Fecha_Creacion_Inicio: Fecha_Creacion_Inicio,
      Fecha_Creacion_Fin: Fecha_Creacion_Fin,
      Departamento: Departamento,
      Area: Area,
      Tipo_Puesto: Tipo_Puesto,
      Tipo_Contratacion: Tipo_Contratacion,
      Tipo_Personal: Tipo_Personal,
      Jornada_Trabajo: Jornada_Trabajo,
      Sexo: Sexo,
      sUsuarios: sUsuarios == undefined ? "" : sUsuarios,
    })
  );
  const URL = RutaBase + "api/RVGlobal";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IdEncuesta: IdEncuesta,
      IdEncuestaEmpresa: IdEncuestaEmpresa,
      IdUsuario: IdUsuario,
      Fecha_Creacion_Inicio: Fecha_Creacion_Inicio,
      Fecha_Creacion_Fin: Fecha_Creacion_Fin,
      Departamento: Departamento,
      Area: Area,
      Tipo_Puesto: Tipo_Puesto,
      Tipo_Contratacion: Tipo_Contratacion,
      Tipo_Personal: Tipo_Personal,
      Jornada_Trabajo: Jornada_Trabajo,
      Sexo: Sexo,
      sUsuarios: sUsuarios == undefined ? "" : sUsuarios,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const RVVerEmpleadosEvaluados = (
  IdEncuesta,
  IdEncuestaEmpresa,
  IdUsuario,
  Fecha_Creacion_Inicio,
  Fecha_Creacion_Fin,
  Departamento,
  Area,
  Tipo_Puesto,
  Tipo_Contratacion,
  Tipo_Personal,
  Jornada_Trabajo,
  Sexo
) => {
  const URL = RutaBase + "api/RVVerEmpleadosEvaluados";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IdEncuesta: IdEncuesta,
      IdEncuestaEmpresa: IdEncuestaEmpresa,
      IdUsuario: IdUsuario,
      Fecha_Creacion_Inicio: Fecha_Creacion_Inicio,
      Fecha_Creacion_Fin: Fecha_Creacion_Fin,
      Departamento: Departamento,
      Area: Area,
      Tipo_Puesto: Tipo_Puesto,
      Tipo_Contratacion: Tipo_Contratacion,
      Tipo_Personal: Tipo_Personal,
      Jornada_Trabajo: Jornada_Trabajo,
      Sexo: Sexo,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const RVVerEmpleadosPorRiesgo = (
  IdEncuesta,
  IdEncuestaEmpresa,
  IdUsuario,
  Fecha_Creacion_Inicio,
  Fecha_Creacion_Fin,
  Nivel,
  Guia,
  Departamento,
  Area,
  Tipo_Puesto,
  Tipo_Contratacion,
  Tipo_Personal,
  Jornada_Trabajo,
  Sexo
) => {
  const URL = RutaBase + "api/RVVerEmpleadosPorRiesgo";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IdEncuesta: IdEncuesta,
      IdEncuestaEmpresa: IdEncuestaEmpresa,
      IdUsuario: IdUsuario,
      Fecha_Creacion_Inicio: Fecha_Creacion_Inicio,
      Fecha_Creacion_Fin: Fecha_Creacion_Fin,
      Nivel: Nivel,
      Guia: Guia,
      Departamento: Departamento,
      Area: Area,
      Tipo_Puesto: Tipo_Puesto,
      Tipo_Contratacion: Tipo_Contratacion,
      Tipo_Personal: Tipo_Personal,
      Jornada_Trabajo: Jornada_Trabajo,
      Sexo: Sexo,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const RVVerPreguntasPorCategoriaDominio = (
  IdEncuesta,
  IdEncuestaEmpresa,
  IdUsuario,
  Fecha_Creacion_Inicio,
  Fecha_Creacion_Fin,
  Guia,
  Categoria,
  Dominio,
  Pregunta,
  Respuesta,
  Obtener,
  Departamento,
  Area,
  Tipo_Puesto,
  Tipo_Contratacion,
  Tipo_Personal,
  Jornada_Trabajo,
  Sexo,
  sUsuarios
) => {
  console.log(
    "RVVerPreguntasPorCategoriaDominio",
    JSON.stringify({
      IdEncuesta: IdEncuesta,
      IdEncuestaEmpresa: IdEncuestaEmpresa,
      IdUsuario: IdUsuario,
      Fecha_Creacion_Inicio: Fecha_Creacion_Inicio,
      Fecha_Creacion_Fin: Fecha_Creacion_Fin,
      Guia: Guia,
      Categoria: Categoria,
      Dominio: Dominio,
      Pregunta: Pregunta,
      Respuesta: Respuesta,
      Obtener: Obtener,
      Departamento: Departamento,
      Area: Area,
      Tipo_Puesto: Tipo_Puesto,
      Tipo_Contratacion: Tipo_Contratacion,
      Tipo_Personal: Tipo_Personal,
      Jornada_Trabajo: Jornada_Trabajo,
      Sexo: Sexo,
      sUsuarios: sUsuarios == undefined ? "" : sUsuarios,
    })
  );

  const URL = RutaBase + "api/RVVerPreguntasPorCategoriaDominio";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IdEncuesta: IdEncuesta,
      IdEncuestaEmpresa: IdEncuestaEmpresa,
      IdUsuario: IdUsuario,
      Fecha_Creacion_Inicio: Fecha_Creacion_Inicio,
      Fecha_Creacion_Fin: Fecha_Creacion_Fin,
      Guia: Guia,
      Categoria: Categoria,
      Dominio: Dominio,
      Pregunta: Pregunta,
      Respuesta: Respuesta,
      Obtener: Obtener,
      Departamento: Departamento,
      Area: Area,
      Tipo_Puesto: Tipo_Puesto,
      Tipo_Contratacion: Tipo_Contratacion,
      Tipo_Personal: Tipo_Personal,
      Jornada_Trabajo: Jornada_Trabajo,
      Sexo: Sexo,
      sUsuarios: sUsuarios == undefined ? "" : sUsuarios,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};
export const RVSelectCatalogo = (Catalogo, IdEmpresa) => {
  //React Select
  const URL = RutaBase + "api/RVSelectCatalogo";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      Catalogo: Catalogo,
      IdEmpresa: IdEmpresa,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const RVVerEncuestasRealizadasPorDia = (
  IdEncuesta,
  IdEncuestaEmpresa,
  IdUsuario,
  Fecha_Creacion_Inicio,
  Fecha_Creacion_Fin
) => {
  const URL = RutaBase + "api/RVVerEncuestasRealizadasPorDia";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IdEncuesta: IdEncuesta,
      IdEncuestaEmpresa: IdEncuestaEmpresa,
      IdUsuario: IdUsuario,
      Fecha_Creacion_Inicio: Fecha_Creacion_Inicio,
      Fecha_Creacion_Fin: Fecha_Creacion_Fin,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const RVConsultarPreguntasExtras = (
  IdEncuesta,
  IdEncuestaEmpresa,
  IdUsuario,
  Fecha_Creacion_Inicio,
  Fecha_Creacion_Fin,
  Departamento,
  Area,
  Tipo_Puesto,
  Tipo_Contratacion,
  Tipo_Personal,
  Jornada_Trabajo,
  Sexo
) => {
  const URL = RutaBase + "api/RVConsultarPreguntasExtras";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IdEncuesta: IdEncuesta,
      IdEncuestaEmpresa: IdEncuestaEmpresa,
      IdUsuario: IdUsuario,
      Fecha_Creacion_Inicio: Fecha_Creacion_Inicio,
      Fecha_Creacion_Fin: Fecha_Creacion_Fin,
      Departamento: Departamento,
      Area: Area,
      Tipo_Puesto: Tipo_Puesto,
      Tipo_Contratacion: Tipo_Contratacion,
      Tipo_Personal: Tipo_Personal,
      Jornada_Trabajo: Jornada_Trabajo,
      Sexo: Sexo,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const RVVerEmpleadosPorPreguntaRespuesta = (
  IdEncuestaEmpresa,
  IdEncuesta,
  Fecha_Creacion_Inicio,
  Fecha_Creacion_Fin,
  IdPregunta,
  IdRespuesta,
  Departamento,
  Area,
  Tipo_Puesto,
  Tipo_Contratacion,
  Tipo_Personal,
  Jornada_Trabajo,
  Sexo
) => {
  const URL = RutaBase + "api/RVVerEmpleadosPorPreguntaRespuesta";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IdEncuestaEmpresa: IdEncuestaEmpresa,
      IdEncuesta: IdEncuesta,
      Fecha_Creacion_Inicio: Fecha_Creacion_Inicio,
      Fecha_Creacion_Fin: Fecha_Creacion_Fin,
      IdPregunta: IdPregunta,
      IdRespuesta: IdRespuesta,
      Departamento: Departamento,
      Area: Area,
      Tipo_Puesto: Tipo_Puesto,
      Tipo_Contratacion: Tipo_Contratacion,
      Tipo_Personal: Tipo_Personal,
      Jornada_Trabajo: Jornada_Trabajo,
      Sexo: Sexo,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

//PDF REPORTES
export const PDFEncuestaEmpleado = (
  IdEncuesta,
  IdEncuestaEmpresa,
  IdUsuario,
  Guia1,
  Guia2,
  Guia3
) => {
  console.log(
    "AQUI",
    IdEncuesta,
    "---",
    IdEncuestaEmpresa,
    "---",
    IdUsuario,
    "---",
    Guia1,
    "---",
    Guia2,
    "---",
    Guia3,
    "FIN"
  );
  const URL = RutaBase + "api/PDFEncuestaEmpleadoV2";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IdEncuesta: IdEncuesta,
      IdEncuestaEmpresa: IdEncuestaEmpresa,
      IdUsuario: IdUsuario,
      Guia1: "", //Guia1,
      Guia2: "", //Guia2,
      Guia3: "", //Guia3
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};
export const PDFListadoEncuestas = (
  IdEncuesta,
  IdEncuestaEmpresa,
  IdUsuario,
  Fecha_Creacion_Inicio,
  Fecha_Creacion_Fin,
  Departamento,
  Area,
  Tipo_Puesto,
  Tipo_Contratacion,
  Tipo_Personal,
  Jornada_Trabajo,
  Sexo
) => {
  const URL = RutaBase + "api/PDFListadoEncuestas";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IdEncuesta: IdEncuesta,
      IdEncuestaEmpresa: IdEncuestaEmpresa,
      IdUsuario: IdUsuario,
      Fecha_Creacion_Inicio: Fecha_Creacion_Inicio,
      Fecha_Creacion_Fin: Fecha_Creacion_Fin,
      Departamento: Departamento,
      Area: Area,
      Tipo_Puesto: Tipo_Puesto,
      Tipo_Contratacion: Tipo_Contratacion,
      Tipo_Personal: Tipo_Personal,
      Jornada_Trabajo: Jornada_Trabajo,
      Sexo: Sexo,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};
export const PDFEmpleadosRequierenAtencionMedica = (
  IdEncuestaEmpresa,
  Guia1
) => {
  const URL = RutaBase + "api/PDFEmpleadosRequierenAtencionMedica";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IdEncuestaEmpresa: IdEncuestaEmpresa,
      Guia1: { guia: Guia1 },
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};
export const PDFFactorRiesgoPsicosocial = (IdEncuestaEmpresa, Guia2) => {
  const URL = RutaBase + "api/PDFFactorRiesgoPsicosocial";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IdEncuestaEmpresa: IdEncuestaEmpresa,
      Guia2: { guia: Guia2 },
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};
export const PDFFactorRiesgoEntornoOrganizacional = (
  IdEncuestaEmpresa,
  Guia3
) => {
  const URL = RutaBase + "api/PDFFactorRiesgoEntornoOrganizacional";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IdEncuestaEmpresa: IdEncuestaEmpresa,
      Guia3: { guia: Guia3 },
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};
export const PDFReporteOficial = (
  IdEncuesta,
  IdEncuestaEmpresa,
  IdUsuario,
  Fecha_Creacion_Inicio,
  Fecha_Creacion_Fin,
  Departamento,
  Area,
  Tipo_Puesto,
  Tipo_Contratacion,
  Tipo_Personal,
  Jornada_Trabajo,
  Sexo
) => {
  const URL = RutaBase + "api/PDFReporteOficial";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IdEncuesta: IdEncuesta,
      IdEncuestaEmpresa: IdEncuestaEmpresa,
      IdUsuario: IdUsuario,
      Fecha_Creacion_Inicio: Fecha_Creacion_Inicio,
      Fecha_Creacion_Fin: Fecha_Creacion_Fin,
      Departamento: Departamento,
      Area: Area,
      Tipo_Puesto: Tipo_Puesto,
      Tipo_Contratacion: Tipo_Contratacion,
      Tipo_Personal: Tipo_Personal,
      Jornada_Trabajo: Jornada_Trabajo,
      Sexo: Sexo,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};
export const PDFPreguntasExtras = (
  IdEncuesta,
  IdEncuestaEmpresa,
  IdUsuario,
  Fecha_Creacion_Inicio,
  Fecha_Creacion_Fin,
  Departamento,
  Area,
  Tipo_Puesto,
  Tipo_Contratacion,
  Tipo_Personal,
  Jornada_Trabajo,
  Sexo
) => {
  const URL = RutaBase + "api/PDFPreguntasExtras";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IdEncuesta: IdEncuesta,
      IdEncuestaEmpresa: IdEncuestaEmpresa,
      IdUsuario: IdUsuario,
      Fecha_Creacion_Inicio: Fecha_Creacion_Inicio,
      Fecha_Creacion_Fin: Fecha_Creacion_Fin,
      Departamento: Departamento,
      Area: Area,
      Tipo_Puesto: Tipo_Puesto,
      Tipo_Contratacion: Tipo_Contratacion,
      Tipo_Personal: Tipo_Personal,
      Jornada_Trabajo: Jornada_Trabajo,
      Sexo: Sexo,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const ImportarTrabajadores = (IDEmpresa, Datos, SiExisteActualizar) => {
  const URL = RutaBase + "api/ImportarTrabajadores";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDEmpresa: IDEmpresa,
      Datos: { Trabajadores: Datos },
      SiExisteActualizar: SiExisteActualizar,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

/*
                                  export const NuevaEncuestaEmpresa = (IDsUsuarios, IDsUsuariosPush, sCorreos, IDEmpresa, IDSetPreguntas,
                                  Nombre, TipoEncuesta, Estado, Estatus) => {
                                  const URL = RutaBase + 'api/NuevaEncuestaEmpresa';
                                  return fetch(URL, {
                                  method: 'POST',
                                  headers: {
                                  Accept: 'application/json',
                                  'Content-Type': 'application/json',
                                },
                                body: JSON.stringify({
                                IDsUsuarios: IDsUsuarios,
                                IDsUsuariosPush: IDsUsuariosPush,
                                sCorreos: sCorreos,
                                IDEmpresa: IDEmpresa,
                                IDSetPreguntas: IDSetPreguntas,
                                Nombre: Nombre,
                                TipoEncuesta: TipoEncuesta,
                                Estado: Estado,
                                Estatus: Estatus
                              }),
                            }).then((response) => response.json())
                            .catch((error) => {
                            console.warn(error);
                          });
                        };


                        export const ActualizarEncuestaEmpresa = (IDEmpresa, IDEncuestaEmpresa, Nombre, Estado) => {
                        const URL = RutaBase + 'api/ActualizarEncuestaEmpresa';
                        return fetch(URL, {
                        method: 'POST',
                        headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                      },
                      body: JSON.stringify({
                      IDEmpresa: IDEmpresa,
                      IDEncuestaEmpresa: IDEncuestaEmpresa,
                      Nombre: Nombre,
                      Estado: Estado
                    }),
                  }).then((response) => response.json())
                  .catch((error) => {
                  console.warn(error);
                });
              };*/

export const GuardarEncuestaEmpresa = (
  IDEncuestaEmpresa,
  IDsUsuarios,
  IDsUsuariosPush,
  sCorreos,
  IDEmpresa,
  IDSetPreguntas,
  Nombre,
  TipoEncuesta,
  Estado,
  Estatus,
  MensajeEntrada,
  MensajeSalida,
  aCodNomina,
  Fecha_Limite,
  GuardarLanzar
) => {
  const URL = RutaBase + "api/GuardarEncuestaEmpresa";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDEncuestaEmpresa: IDEncuestaEmpresa,
      IDsUsuarios: IDsUsuarios,
      IDsUsuariosPush: IDsUsuariosPush,
      sCorreos: sCorreos,
      IDEmpresa: IDEmpresa,
      IDSetPreguntas: IDSetPreguntas,
      Nombre: Nombre,
      TipoEncuesta: TipoEncuesta,
      Estado: Estado,
      Estatus: Estatus,
      MensajeEntrada: MensajeEntrada,
      MensajeSalida: MensajeSalida,
      CodNomina: aCodNomina,
      Fecha_Limite: Fecha_Limite,
      GuardarLanzar: GuardarLanzar,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const ActualizarEncuestaUsuario = (
  IDEncuesta,
  IDEmpresa,
  IDUsuario,
  Estatus
) => {
  const URL = RutaBase + "api/ActualizarEncuestaUsuario";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDEncuesta: IDEncuesta,
      IDEmpresa: IDEmpresa,
      IDUsuario: IDUsuario,
      Estatus: Estatus,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const RecuperarContrasenaCMS = (usuario, pass) => {
  const URL = RutaBase + "api/RecuperarContrasenaCMS";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      usuario: usuario,
      pass: pass,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      // console.warn(error);
    });
};

//

export const IniciarSesion = (User, Pass) => {
  console.log(User, Pass);
  const URL = RutaBase + "api/login";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      usuario: User,
      contrasena: Pass,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      // console.warn(error);
    });
};

export const Registrarse = (
  Usuario,
  IDEmpresa,
  Pass,
  Codigo,
  Nombre,
  Apellido_Paterno,
  Apellido_Materno,
  Descripcion,
  Puesto,
  Numero_Telefono,
  Sexo,
  Fecha_Nacimiento,
  Estado_Civil,
  Nivel_Estudios,
  Area,
  Departamento,
  Tipo_Puesto,
  Contrato,
  Tipo_Contratacion,
  Tipo_Personal,
  Jornada_Trabajo,
  Rotacion_Turno,
  Fecha_Contratacion,
  Fecha_Nuevo_Puesto,
  fileImagen,
  Permisos,
  MInicio,
  MMiEmpresa,
  MMisTrabajadores,
  MEncuestas,
  MConfiguracionEncuestas,
  MMonitoreoEncuestas,
  MReportesNorma,
  MReportesValor,
  MIncidencias,
  MCentroMensajes,
  MAvisos,
  MAyuda,
  IDUsuarioCrea
) => {
  const formData = new FormData();
  formData.append("Usuario", Usuario);
  formData.append("IDEmpresa", IDEmpresa);
  formData.append("Pass", Pass);
  formData.append("Codigo", Codigo);
  formData.append("Nombre", Nombre);
  formData.append("Apellido_Paterno", Apellido_Paterno);
  formData.append("Apellido_Materno", Apellido_Materno);
  formData.append("Descripcion", Descripcion);
  formData.append("Puesto", Puesto);
  formData.append("Numero_Telefono", Numero_Telefono);
  formData.append("Sexo", Sexo);
  formData.append("Fecha_Nacimiento", Fecha_Nacimiento);
  formData.append("Estado_Civil", Estado_Civil);
  formData.append("Nivel_Estudios", Nivel_Estudios);
  formData.append("Area", Area);
  formData.append("Departamento", Departamento);
  formData.append("Tipo_Puesto", Tipo_Puesto);
  formData.append("Contrato", Contrato);
  formData.append("Tipo_Contratacion", Tipo_Contratacion);
  formData.append("Tipo_Personal", Tipo_Personal);
  formData.append("Jornada_Trabajo", Jornada_Trabajo);
  formData.append("Rotacion_Turno", Rotacion_Turno);
  formData.append("Fecha_Contratacion", Fecha_Contratacion);
  formData.append("Fecha_Nuevo_Puesto", Fecha_Nuevo_Puesto);
  //Imagen: 'images/user-default.png',
  formData.append("fileImagen", fileImagen);
  formData.append("Permisos", Permisos);
  formData.append("MInicio", MInicio);
  formData.append("MMiEmpresa", MMiEmpresa);
  formData.append("MMisTrabajadores", MMisTrabajadores);
  formData.append("MEncuestas", MEncuestas);
  formData.append("MConfiguracionEncuestas", MConfiguracionEncuestas);
  formData.append("MMonitoreoEncuestas", MMonitoreoEncuestas);
  formData.append("MReportesNorma", MReportesNorma);
  formData.append("MReportesValor", MReportesValor);
  formData.append("MIncidencias", MIncidencias);
  formData.append("MCentroMensajes", MCentroMensajes);
  formData.append("MAvisos", MAvisos);
  formData.append("MAyuda", MAyuda);
  formData.append("IDUsuarioCrea", IDUsuarioCrea);

  const url = RutaBase + "api/Registro";
  return fetch(url, {
    method: "POST",
    body: formData,
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const RegistroCMS = (
  user,
  pass,
  nombre,
  apellidop,
  apellidom,
  puesto,
  permisos,
  idususariocrea,
  lidercuadrilla
) => {
  const URL = RutaBase + "api/RegistroCMS";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      Usuario: user,
      Pass: pass,
      Nombre: nombre,
      Apellido_Paterno: apellidop,
      Apellido_Materno: apellidom,
      Puesto: puesto,
      Permisos: permisos,
      IDUsuarioCrea: idususariocrea,
      LiderCuadrilla: lidercuadrilla,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      // console.warn(error);
    });
};

export const Olvidecontrasena = (email) => {
  //let Domain  = domain;
  //let ID = id;
  //let Nip = nip;
  const URL = RutaBase + "api/EnviaCorreoHtml";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      Usuario: email,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const Restablececontrasena = (email, pass) => {
  //let Domain  = domain;
  //let ID = id;
  //let Nip = nip;
  const URL = RutaBase + "api/RestableceContrasena";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      Usuario: email,
      Pass: pass,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const MuestraEncuesta = (idsetpreguntas) => {
  const URL = RutaBase + "api/MostrarPreguntasRespuestas";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDSetPreguntas: idsetpreguntas,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const IniciarEncuesta = (
  idusuario,
  personaencuesta,
  ubicacion,
  latitud,
  longitud,
  cp,
  colonia,
  edad,
  telefono,
  calle
) => {
  const URL = RutaBase + "api/IniciarEncuesta";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDUsuario: idusuario,
      PersonaEncuenta: personaencuesta,
      Ubicacion: ubicacion,
      Latitud: latitud,
      Longitud: longitud,
      CP: cp,
      Colonia: colonia,
      Edad: edad,
      Telefono: telefono,
      Calle: calle,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const GuardarRespuesta = (
  idencuesta,
  idsetpregunta,
  idpregunta,
  idrespuesta
) => {
  const URL = RutaBase + "api/ContestarPregunta";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDEncuesta: idencuesta,
      IDSetPregunta: idsetpregunta,
      IDPregunta: idpregunta,
      IDRespuesta: idrespuesta,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const FinalizaEncuesta = (idusuario, idencuesta) => {
  const URL = RutaBase + "api/CerrarEncuesta";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDUsuario: idusuario,
      IDEncuesta: idencuesta,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const ObtieneSetActivo = (fecha) => {
  const URL = RutaBase + "api/ObtieneSetActivo";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      Fecha: fecha,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const ObtieneDireccion = (latitud, longitud) => {
  const URL =
    "https://api.opencagedata.com/geocode/v1/json?q=" +
    latitud +
    "+" +
    longitud +
    "&key=7338f618b63d404e94542975764df7c6";
  return fetch(URL, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const RespuestaMasVotada = (tipo) => {
  const URL = RutaBase + "api/RespuestasMasVotada";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      Tipo: tipo,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const Resultados = (idusuario, idcuadrilla) => {
  const URL = RutaBase + "api/MuestraResultados";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDUsuario: idusuario,
      IDCuadrilla: idcuadrilla,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const MapaResultadoUbicacion = (tipo) => {
  const URL = RutaBase + "api/MapaResultadoUbicacion";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      Tipo: tipo,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const ActivarUsuarioCMS = (idusuario) => {
  const URL = RutaBase + "api/ActivarUsuarioCMS";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDUsuario: idusuario,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const MapaResultadoDomicilio = (tipo) => {
  const URL = RutaBase + "api/MapaResultadoDomicilio";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      Tipo: tipo,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const ObtieneColonias = (CodigoPostal) => {
  const URL =
    "https://api-codigos-postales.herokuapp.com/v2/codigo_postal/" +
    CodigoPostal;
  return fetch(URL, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const ColoniasMasVotos = (tipo) => {
  const URL = RutaBase + "api/ColoniaMasVotos";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      Tipo: tipo,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const ActualizarUsuario = (
  Usuario,
  IDUsuario,
  IDEmpresa,
  Codigo,
  Usuario_Modificar,
  Nombre,
  Apellido_Paterno,
  Apellido_Materno,
  Descripcion,
  Puesto,
  Numero_Telefono,
  Sexo,
  Fecha_Nacimiento,
  Estado_Civil,
  Nivel_Estudios,
  Area,
  Departamento,
  Tipo_Puesto,
  Contrato,
  Tipo_Contratacion,
  Tipo_Personal,
  Jornada_Trabajo,
  Rotacion_Turno,
  Fecha_Contratacion,
  Fecha_Nuevo_Puesto,
  Imagen,
  fileImagen,
  Permisos,
  MInicio,
  MMiEmpresa,
  MMisTrabajadores,
  MEncuestas,
  MConfiguracionEncuestas,
  MMonitoreoEncuestas,
  MReportesNorma,
  MReportesValor,
  MIncidencias,
  MCentroMensajes,
  MAvisos,
  MAyuda
) => {
  const formData = new FormData();
  formData.append("Usuario", Usuario);
  formData.append("IDUsuario", IDUsuario);
  formData.append("IDEmpresa", IDEmpresa);
  formData.append("Codigo", Codigo);
  formData.append("Usuario_Modificar", Usuario_Modificar);
  formData.append("Nombre", Nombre);
  formData.append("Apellido_Paterno", Apellido_Paterno);
  formData.append("Apellido_Materno", Apellido_Materno);
  formData.append("Descripcion", Descripcion);
  formData.append("Puesto", Puesto);
  formData.append("Numero_Telefono", Numero_Telefono);
  formData.append("Sexo", Sexo);
  formData.append("Fecha_Nacimiento", Fecha_Nacimiento);
  formData.append("Estado_Civil", Estado_Civil);
  formData.append("Nivel_Estudios", Nivel_Estudios);
  formData.append("Area", Area);
  formData.append("Departamento", Departamento);
  formData.append("Tipo_Puesto", Tipo_Puesto);
  formData.append("Contrato", Contrato);
  formData.append("Tipo_Contratacion", Tipo_Contratacion);
  formData.append("Tipo_Personal", Tipo_Personal);
  formData.append("Jornada_Trabajo", Jornada_Trabajo);
  formData.append("Rotacion_Turno", Rotacion_Turno);
  formData.append("Fecha_Contratacion", Fecha_Contratacion);
  formData.append("Fecha_Nuevo_Puesto", Fecha_Nuevo_Puesto);
  formData.append("Imagen", Imagen);
  formData.append("fileImagen", fileImagen);
  formData.append("Permisos", Permisos);
  formData.append("MInicio", MInicio);
  formData.append("MMiEmpresa", MMiEmpresa);
  formData.append("MMisTrabajadores", MMisTrabajadores);
  formData.append("MEncuestas", MEncuestas);
  formData.append("MConfiguracionEncuestas", MConfiguracionEncuestas);
  formData.append("MMonitoreoEncuestas", MMonitoreoEncuestas);
  formData.append("MReportesNorma", MReportesNorma);
  formData.append("MReportesValor", MReportesValor);
  formData.append("MIncidencias", MIncidencias);
  formData.append("MCentroMensajes", MCentroMensajes);
  formData.append("MAvisos", MAvisos);
  formData.append("MAyuda", MAyuda);

  const url = RutaBase + "api/ActualizaUsuario";
  return fetch(url, {
    method: "POST",
    body: formData,
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const EliminarUsuario = (
  IDUsuario,
  IDUsuario_modificar,
  Status,
  Modo
) => {
  const URL = RutaBase + "api/EliminarUsuario";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDUsuario: IDUsuario,
      IDUsuario_modificar: IDUsuario_modificar,
      Status: Status,
      Modo: Modo,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {});
};

export const EliminarCuadrilla = (idcuadrilla) => {
  const URL = RutaBase + "api/EliminarCuadrilla";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDCuadrilla: idcuadrilla,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const CreaPregunta = (
  descripcion,
  IDEmpresa,
  idusuario,
  ponderancia,
  respuestamultiple
) => {
  const URL = RutaBase + "api/CrearPregunta";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      DescripcionPregunta: descripcion,
      IDEmpresa: IDEmpresa,
      IDUsuario: idusuario,
      NoPoderanciambre: ponderancia,
      RespuestaMultiple: respuestamultiple,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const CreaRespuesta = (descripcion, idusuario, tipo, respuestalibre) => {
  const URL = RutaBase + "api/CrearRespuesta";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      DescripcionRespuesta: descripcion,
      idusuario: idusuario,
      RespuestaLibre: respuestalibre,
      Tipo: tipo,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const MuestraPreguntas = (idsetpreguntas) => {
  const URL = RutaBase + "api/MostrarPreguntas";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDSetPreguntas: idsetpreguntas,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const MuestraRespuesta = (idsetpreguntas) => {
  const URL = RutaBase + "api/MostrarRespuesta";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({}),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const BorrarRespuesta = (idrespuesta, status, idusuario) => {
  const URL = RutaBase + "api/BorrarRespuesta";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDRespuesta: idrespuesta,
      Status: status,
      IDUsuario: idusuario,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const BorrarPreguntas = (idpregunta, status, idusuario) => {
  const URL = RutaBase + "api/BorrarPreguntas";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDPregunta: idpregunta,
      Status: status,
      IDUsuario: idusuario,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const ActualizaRespuesta = (descripcion, idusuario, idrespuesta) => {
  const URL = RutaBase + "api/ModificarRespuesta";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      DescripcionPregunta: descripcion,
      IDUsuario: idusuario,
      IDRespuesta: idrespuesta,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const ActualizaPregunta = (
  descripcion,
  RespuestaMultiple,
  idusuario,
  idpregunta
) => {
  const URL = RutaBase + "api/ModificarPreguntas";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      DescripcionPregunta: descripcion,
      RespuestaMultiple: RespuestaMultiple,
      IDUsuario: idusuario,
      IDPregunta: idpregunta,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const MostrarSetPreguntas = (idsetpregunta, IDEmpresa) => {
  const URL = RutaBase + "api/MostrarSetPreguntas";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDSetPreguntas: idsetpregunta,
      IDEmpresa: IDEmpresa,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const EncuestaPeriodo = (
  fechainicialmes,
  fechafinmes,
  fechainicioanual,
  fechafinanual,
  fechainiciodiario
) => {
  const URL = RutaBase + "api/EncuestaPeriodo";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      FechaInicioMes: fechainicialmes,
      FechaFinMes: fechafinmes,
      FechaInicioAnual: fechainicioanual,
      FechaFinAnual: fechafinanual,
      FechaInicioDiario: fechainiciodiario,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const EncuestaTodosMeses = (fechainicioanual, fechafinanual) => {
  const URL = RutaBase + "api/EncuestaTodosMeses";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      FechaInicioAnual: fechainicioanual,
      FechaFinAnual: fechafinanual,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const MostrarPreguntasSinConAsignar = (idsetpreguntas) => {
  const URL = RutaBase + "api/MostrarPreguntasSinConAsignar";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDSetPreguntas: idsetpreguntas,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const AsignarPregunta = (idsetpregunta, idpregunta, orden) => {
  const URL = RutaBase + "api/AsignarPregunta";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDSetPregunta: idsetpregunta,
      IDPregunta: idpregunta,
      Orden: orden,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const Desasigna = (idsetpregunta, idpregunta, orden) => {
  const URL = RutaBase + "api/Desasigna";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDSetPregunta: idsetpregunta,
      IDPregunta: idpregunta,
      Orden: orden,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const MostrarRespuesta = (idsetpregunta) => {
  const URL = RutaBase + "api/Desasigna";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDSetPregunta: idsetpregunta,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const MostrarRespuestaSinConAsignar = (idpregunta) => {
  const URL = RutaBase + "api/MostrarRespuestaSinConAsignar";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDPregunta: idpregunta,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const Desasigna_Respuesta = (idrespuesta, idpregunta) => {
  const URL = RutaBase + "api/Desasigna_RespuestaDefault";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDRespuesta: idrespuesta,
      IDPregunta: idpregunta,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const AsignarRespuesta = (idpregunta, idrespuesta, orden) => {
  const URL = RutaBase + "api/AsignarRespuesta";
  console.log("AsignarRespuesta", idrespuesta, orden);
  return fetch(URL, {
    method: "POST",

    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDPregunta: idpregunta,
      IDRespuesta: idrespuesta,
      Orden: orden,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const BorrarSetPreguntas = (idsetpregunta, status, idusuario) => {
  const URL = RutaBase + "api/BorrarSetPreguntas";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDSetPregunta: idsetpregunta,
      Status: status,
      IDUsuario: idusuario,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const TopTresEncuestadores = (fechainiciomes, fechafinmes) => {
  const URL = RutaBase + "api/TopTresEncuestadores";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      FechaInicioMes: fechainiciomes,
      FechaFinMes: fechafinmes,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const TopTodosEncuestadores = (fechainiciomes, fechafinmes) => {
  const URL = RutaBase + "api/TopTodosEncuestadores";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      FechaInicioMes: fechainiciomes,
      FechaFinMes: fechafinmes,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const GuardarSetPreguntas = (
  IDSetPreguntas,
  MensajeEntrada,
  descripcion,
  IDEmpresa,
  idusuario
) => {
  const URL = RutaBase + "api/GuardarSetPreguntas";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDSetPreguntas: IDSetPreguntas,
      MensajeEntrada: MensajeEntrada,
      Descripcion: descripcion,
      IDEmpresa: IDEmpresa,
      IDUsuario: idusuario,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const OrdenRespuesta = (idrespuesta, idpregunta, orden) => {
  const URL = RutaBase + "api/OrdenaRespuestas";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDRespuesta: idrespuesta,
      IDPregunta: idpregunta,
      Orden: orden,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const OrdenaPreguntas = (idsetpregunta, idpregunta, orden) => {
  const URL = RutaBase + "api/OrdenaPreguntas";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDSetPregunta: idsetpregunta,
      IDPregunta: idpregunta,
      Orden: orden,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const MostrarUsuarios = () => {
  const URL = RutaBase + "api/MostrarUsuarios";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({}),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const ListadoUsuariosPendientes = () => {
  const URL = RutaBase + "api/ListadoUsuariosPendientesCMS";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({}),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const CrearCuadrilla = (nombrecuadrilla, idlidercuadrilla, idzona) => {
  const URL = RutaBase + "api/CrearCuadrilla";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      NombreCuadrilla: nombrecuadrilla,
      IDLiderCuadrilla: idlidercuadrilla,
      IDZona: idzona,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const MostrarCuadrilla = () => {
  const URL = RutaBase + "api/MostrarCuadrilla";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDSetPreguntas: "",
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const MuestraIntegrantesCuadrilla = (idusuario, idcuadrilla) => {
  const URL = RutaBase + "api/MuestraIntegrantesCuadrilla";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDUsuario: idusuario,
      IDCuadrilla: idcuadrilla,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const AsignaDesasignaUsuarioCuadrilla = (idusuario, idcuadrilla) => {
  const URL = RutaBase + "api/Asigna_Desasigna_Usuario_Cuadrilla";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDUsuario: idusuario,
      IDCuadrilla: idcuadrilla,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const ListadoSetPreguntas = (idsetpreguntas) => {
  const URL = RutaBase + "api/ListadoSetPreguntas";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDSetPreguntas: idsetpreguntas,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const MuestraListaPreguntasDependencia = (
  idpregunta,
  idsetpreguntas
) => {
  const URL = RutaBase + "api/MuestraListaPreguntasDependencia";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDPregunta: idpregunta,
      IDSetPregunta: idsetpreguntas,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const MuestraListaRespuestaDependencia = (idpregunta) => {
  const URL = RutaBase + "api/MuestraListaRespuestaDependencia";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDPregunta: idpregunta,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const PersonasEncuestadas = (fechainicio, fechafin, idusuario) => {
  const URL = RutaBase + "api/PersonasEncuestadas";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      FechaInicio: fechainicio,
      FechaFin: fechafin,
      IDUsuario: idusuario,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const ResultadoEvaluacion = (fechainicio, fechafin, estado) => {
  const URL = RutaBase + "api/ResultadoEvaluacion";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      FechaInicio: fechainicio,
      FechaFin: fechafin,
      Estado: estado,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const ResultadoEvaluacionDetalle = (fechainicio, fechafin, estado) => {
  const URL = RutaBase + "api/ResultadoEvaluacionDetalle";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      FechaInicio: fechainicio,
      FechaFin: fechafin,
      Estado: estado,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const EncuestasCC = (fechainicio, fechafin, estado) => {
  const URL = RutaBase + "api/EncuestasCC";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      FechaInicio: fechainicio,
      FechaFin: fechafin,
      Estado: estado,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const ValidaEncuestaCC = (
  idusuario,
  idencuesta,
  comentarios,
  estatuscc
) => {
  const URL = RutaBase + "api/ValidaEncuestaCC";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDUsuario: idusuario,
      IDEncuesta: idencuesta,
      Comentarios: comentarios,
      EstatusCC: estatuscc,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const TopEncuestadores = (fechainicio, fechafin) => {
  const URL = RutaBase + "api/TopEncuestadores";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      FechaInicioMes: fechainicio,
      FechaFinMes: fechafin,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const ResultadoEncuestaPersona = (idencuesta) => {
  const URL = RutaBase + "api/ResultadoEncuestaPersona";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDEncuesta: idencuesta,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const AgregarDependencia = (
  idsetpregunta,
  idpregunta,
  idrespuesta,
  idpreguntasiguiente
) => {
  const URL = RutaBase + "api/GuardaDependencia";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDSetPregunta: idsetpregunta,
      IDPregunta: idpregunta,
      IDRespuesta: idrespuesta,
      IDPreguntaSiguiente: idpreguntasiguiente,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const ActualizarDependencia = (
  idsetpregunta,
  idpregunta,
  idrespuesta,
  idpreguntasiguiente
) => {
  const URL = RutaBase + "api/ActualizarDependencia";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDSetPregunta: idsetpregunta,
      IDPregunta: idpregunta,
      IDRespuesta: idrespuesta,
      IDPreguntaSiguiente: idpreguntasiguiente,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const EliminarDependencia = (
  idsetpregunta,
  idpregunta,
  idrespuesta,
  idpreguntasiguiente
) => {
  const URL = RutaBase + "api/EliminaRespuesta";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDSetPregunta: idsetpregunta,
      IDPregunta: idpregunta,
      IDRespuesta: idrespuesta,
      IDPreguntaSiguiente: idpreguntasiguiente,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const MostrarSolicitudes = (IDEmpresa) => {
  const URL = RutaBase + "api/ListadoSolicitudes";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDEmpresa: IDEmpresa,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const MuestraLiderCuadrilla = () => {
  const URL = RutaBase + "api/MuestraLiderCuadrilla";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const ModificarCuadrilla = (nombrecuadrilla, idusuario, idcuadrilla) => {
  const URL = RutaBase + "api/ModificarCuadrilla";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      NombreCuadrilla: nombrecuadrilla,
      IDusuario: idusuario,
      IDcuadrilla: idcuadrilla,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const ActualizaSolicitud = (
  idsolicitud,
  status,
  Acciones,
  usuariomodifica
) => {
  const URL = RutaBase + "api/ActualizaSolicitud";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDSolicitud: idsolicitud,
      Acciones: Acciones,
      Status: status,
      UsuarioModifica: usuariomodifica,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const CrearSolicitud = (
  descripcionsolicitud,
  tipo,
  status,
  ususariocrea
) => {
  const URL = RutaBase + "api/CrearSolicitud";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      DescripcionSolicitud: descripcionsolicitud,
      Tipo: tipo,
      Status: status,
      UsuarioCrea: ususariocrea,
    }),
  })
    .then((response) => response.jsonstatus())
    .catch((error) => {
      console.warn(error);
    });
};

export const AceptarRechazarEncuesta = (idencuesta, estadoencuesta) => {
  const URL = RutaBase + "api/AceptarRechazarEncuesta";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDEncuesta: idencuesta,
      EstadoEncuesta: estadoencuesta,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const EliminarEncuesta = (idencuesta) => {
  const URL = RutaBase + "api/EliminarEncuesta";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDEncuesta: idencuesta,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const ResultadoEncuestaBecas = (fecha1, fecha2) => {
  const URL = RutaBase + "api/ResultadoBecas";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      fecha_inicio: fecha1,
      fecha_fin: fecha2,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const ResultadoEncuestaJefeFamilia = (fecha1, fecha2) => {
  const URL = RutaBase + "api/ResultadoJefeFamilia";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      fecha_inicio: fecha1,
      fecha_fin: fecha2,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const ResultadoEncuestaAdultosMayores = (fecha1, fecha2) => {
  const URL = RutaBase + "api/ResultadoAdultosMayores";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      fecha_inicio: fecha1,
      fecha_fin: fecha2,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const EntregaApoyo = (idencuesta, apoyoentrega, comentarios) => {
  const URL = RutaBase + "api/EntregaApoyo";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDEncuesta: idencuesta,
      ApoyoEntrega: apoyoentrega,
      ComentariosEncuesta: comentarios,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const ApoyoEntregado = (fechainicio, fechafin) => {
  const URL = RutaBase + "api/ListadoApoyoEntregado";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      FechaInicio: fechainicio,
      FechaFin: fechafin,
      Estado: "",
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const Aprobar_Rechazar_Apoyo = (
  idencuesta,
  estatusapoyo,
  comentariosapoyo
) => {
  const URL = RutaBase + "api/AprobarRechazarApoyo";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDEncuesta: idencuesta,
      EstatusApoyo: estatusapoyo,
      ComentarioApoyo: comentariosapoyo,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const AntecedentesApoyos = (idencuesta) => {
  const URL = RutaBase + "api/AntecedentesApoyos";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDEncuesta: idencuesta,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const AdultosMayoresAprobadas = (fecha1, fecha2) => {
  const URL = RutaBase + "api/AdultosMayoresAprobadas";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      fecha_inicio: fecha1,
      fecha_fin: fecha2,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const AdultosMayoresRechazo = (fecha1, fecha2) => {
  const URL = RutaBase + "api/AdultosMayoresRechazo";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      fecha_inicio: fecha1,
      fecha_fin: fecha2,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const BecaAprobada = (fecha1, fecha2) => {
  const URL = RutaBase + "api/BecasAprobadas";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      fecha_inicio: fecha1,
      fecha_fin: fecha2,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};

export const BecaRechazada = (fecha1, fecha2) => {
  const URL = RutaBase + "api/BecasRechazadas";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      fecha_inicio: fecha1,
      fecha_fin: fecha2,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};
export const JefeFamiliaAprobadas = (fecha1, fecha2) => {
  const URL = RutaBase + "api/JefeFamiliaAprobadas";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      fecha_inicio: fecha1,
      fecha_fin: fecha2,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};
export const JefeFamiliaRechazo = (fecha1, fecha2) => {
  const URL = RutaBase + "api/JefeFamiliaRechazo";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      fecha_inicio: fecha1,
      fecha_fin: fecha2,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.warn(error);
    });
};
export const ConsultarSeccionesPreguntasRespuestas = (
  idempresa,
  IDEncuesta,
  guiareferencia
) => {
  const URL = RutaBase + "api/ConsultarSeccionesPreguntasRespuestas";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDEmpresa: idempresa,
      IDEncuesta: IDEncuesta,
      GuiaReferencia: guiareferencia,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      // console.warn(error);
    });
};
export const ObtenerSecciones = (guiareferencia) => {
  const URL = RutaBase + "api/ObtenerSecciones";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      GuiaReferencia: guiareferencia,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      // console.warn(error);
    });
};
export const MostrarPreguntasRespuestasSeccion = (
  idsetpreguntas,
  idpreguntas,
  idempresa,
  idseccion,
  IDEncuesta
) => {
  const URL = RutaBase + "api/MostrarPreguntasRespuestasSeccion";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDSetPreguntas: idsetpreguntas,
      IDPregunta: idpreguntas,
      IDEmpresa: idempresa,
      IDSeccion: idseccion,
      IDEncuesta: IDEncuesta,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      // console.warn(error);
    });
};
export const MostrarPreguntasRespuestasExtras = (
  idsetpreguntas,
  idempresa,
  IDEncuesta
) => {
  const URL = RutaBase + "api/MostrarPreguntasRespuestasExtras";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDSetPreguntas: idsetpreguntas,
      IDEmpresa: idempresa,
      IDEncuesta: IDEncuesta,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      // console.warn(error);
    });
};
export const ResponderTerminarEncuesta = (
  IdEmpresa,
  IdEncuesta,
  IdUsuario,
  Respuestas
) => {
  const URL = RutaBase + "api/ResponderEncuesta";
  return fetch(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IDEmpresa: IdEmpresa,
      IDEncuesta: IdEncuesta,
      IDUsuario: IdUsuario,
      Respuestas: Respuestas,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      // console.warn(error);
    });
};
